module.exports = __webpack_public_path__ + "img/Add_to_Apple_Wallet_rgb_HK.8da90063.svg";